import { Link } from 'react-router-dom';
import Logout from '../Logout/Logout';
import Filter from '../Filter/Filter';
import Toolbar from '../Toolbar/Toolbar';
import img from '../../assets/icons/logo.svg';
import { IQueryParams } from '../../types/type';
import { setItemToLacalStorage } from '../../helpers/localstorage.helper';
import './header.css';
import { useAppSelector } from '../../store/hooks';

interface HeaderProps {
  filter?: {
    sort: string;
    query: string;
    filterQuery: string;
  };
  setFilter?: (filter: { sort: string; query: string; filterQuery: string }) => void;
  onUserClick?: (id: string) => void;
  params?: IQueryParams[];
}

export default function Header({ filter, setFilter, onUserClick, params }: HeaderProps) {
  const user = useAppSelector((state) => state.user.user);
  const handleSetFilter = (updatedFilter: { query: string; filterQuery: string }) => {
    if (setFilter && filter) {
      setFilter({ ...filter, ...updatedFilter });
    }
  };
  return (
    <header className="header">
      <div className="container" onClick={() => onUserClick && onUserClick('')}>
        <Link to="/account" className="logo__container">
          <img src={img} alt="Лого" />
        </Link>

        <Logout />
        {user?.role !== 'autopark_employee' && (
          <>
            <Filter
              filter={{
                query: filter?.query || '',
                filterQuery: filter?.filterQuery || 'fullName',
              }}
              setFilter={handleSetFilter}
              params={params ? params : undefined}
            />
            <Toolbar />
          </>
        )}
      </div>
    </header>
  );
}
